import CircularButton from "@/components/CircularButton";
import { useThemeContextSelector } from "@/utils/theme";
import { SxProps } from "@mui/material/styles";

export const DropdownCategoryTitle = ({ children }: { children: React.ReactNode }) => {
    const isDarkMode = useThemeContextSelector(state => state.isDarkMode);

    return (
        <div
            style={{
                fontSize: "10.4px",
                fontWeight: 600,
                marginBottom: "4px",
                textTransform: "uppercase",
                color: isDarkMode ? "#A3A3A3" : "#737373",
                paddingLeft: "6px",
                paddingRight: "6px",
            }}
            data-testid="auto-id-cda53d28-cab8-4ac8-bd84-02173bee4c10">
            {children}
        </div>
    );
};

export const DropdownButton = ({
    children,
    isActive,
    onClick,
    disabled,
    style,
    sx,
}: {
    children: React.ReactNode;
    isActive?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    style?: React.CSSProperties;
    sx?: SxProps;
}) => {
    const isDarkMode = useThemeContextSelector(state => state.isDarkMode);

    const buttonStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "8px",
        padding: "6px",
        fontSize: "14px",
        fontWeight: 500,
        color: isDarkMode ? "#A3A3A3" : "#737373",
        textAlign: "left",
        backgroundColor: "transparent",
        width: "100%",
        borderRadius: "4px",
        ...(!isActive &&
            !disabled && {
                "&:hover": {
                    backgroundColor: isDarkMode ? "#171717" : "#F5F5F5",
                    color: isDarkMode ? "#E5E5E5" : "#262626",
                },
            }),
        ...(isActive &&
            !disabled && {
                backgroundColor: isDarkMode ? "#171717" : "#F5F5F5",
                color: isDarkMode ? "#E5E5E5" : "#262626",
            }),
        ...(disabled && {
            color: isDarkMode ? "#525252" : "#A3A3A3",
            cursor: "not-allowed",
        }),
        ...sx,
        ...style,
    };

    return (
        <CircularButton sx={buttonStyle} disabled={disabled} onClick={onClick}>
            {children}
        </CircularButton>
    );
};
